import { theme } from '@hermes/web-components';
import getPalette from './palette.esm.js';
import getOverrides from './overrides.esm.js';

const palette = getPalette(theme);
const wpaTheme = Object.assign(Object.assign({}, theme), { name: 'wpa', palette });
wpaTheme.components = getOverrides(wpaTheme);

export { wpaTheme as default };
